export const getSpacesImportConfig = ({
  spaceGroups,
  spaceTypes,
  measurementUnits,
}) => {
  const spaceGroupSelectOptions = spaceGroups.map(({ id, name }) => ({
    value: id,
    label: name,
  }))

  const dimensionFields = ["length", "width", "depth", "height"]

  const fields = [
    {
      label: "Space Group",
      key: "space_group_id",
      type: "select",
      selectOptions: spaceGroupSelectOptions,
      validators: [{ validate: "required" }],
    },
    {
      label: "Space Name",
      key: "name",
      type: "string",
      validators: [
        { validate: "required" },
        {
          validate: "unique_case_insensitive",
          error: "Duplicate space name in import",
        },
      ],
    },
    {
      label: "Space Type",
      key: "type",
      type: "select",
      selectOptions: spaceTypes,
      validators: [{ validate: "required" }],
    },
    {
      label: "Display Order",
      key: "display_order",
      type: ["number", "integer"],
      validators: [
        { validate: "unique", error: "Duplicate display order in import" },
      ],
    },
    {
      label: "Dockwalk Display Order",
      key: "dockwalk_display_order",
      type: ["number", "integer"],
      validators: [
        {
          validate: "unique",
          error: "Duplicate dockwalk display order in import",
        },
      ],
    },
    {
      label: "Measurement Unit",
      key: "measurement_unit",
      type: "select",
      selectOptions: measurementUnits,
      description: "Unit for length, width, depth, and height dimensions",
      validators: [
        {
          validate: "require_with",
          fields: dimensionFields,
          errorMessage:
            "Measurement unit is required when any dimension is provided",
        },
      ],
    },
    { label: "Length", key: "length", type: "number" },
    { label: "Width", key: "width", type: "number" },
    { label: "Depth", key: "depth", type: "number" },
    { label: "Height", key: "height", type: "number" },
    {
      label: "Expected Revenue",
      key: "expected_revenue",
      type: ["number", { preset: "usd" }],
      description: "Annual expected revenue in dollars",
    },
  ]

  return { fields }
}
